/**
 * SHIM-модуль для autocomplete.js
 */
require('jquery-ui/ui/unique-id')
require('jquery-ui/ui/widget.js')
require('components-jqueryui/ui/widgets/autocomplete.js')
require('components-jqueryui/ui/widgets/menu.js')
